export const getModerationRowActions = ({
	row,
	statusActions = [],
	onStatusUpdate,
	onOpenDetails,
}) => {
	const actions = [];

	if (typeof onStatusUpdate === "function") {
		statusActions.forEach((statusAction) => {
			if (!statusAction?.status) return;

			actions.push({
				key: `status-${statusAction.status}`,
				type: "statusUpdate",
				label: statusAction.label || statusAction.status,
				onClick: () => onStatusUpdate(row, statusAction.status, statusAction),
			});
		});
	}

	if (typeof onOpenDetails === "function") {
		actions.push({
			key: "details",
			type: "detailView",
			label: "Детали",
			optional: true,
			onClick: () => onOpenDetails(row),
		});
	}

	return actions;
};

export const hasModerationRowActions = ({
	statusActions = [],
	onStatusUpdate,
	onOpenDetails,
}) =>
	(typeof onStatusUpdate === "function" && statusActions.length > 0) ||
	typeof onOpenDetails === "function";
